const defaultProps = {
  focusBorderColor: `primary.500`,
}

export default {
  defaultProps,
}
